import { X, ChevronRight } from "lucide-react";

// Mandatory "check before you send" gate for the public Pakta form.
// Purely a visual confirmation layer — it does NOT validate anything (the server-side
// guards + NPM normalisation are unchanged). It just shows the PPDS exactly what is about
// to be sent (Nama, NPM, live signature preview) and forces an explicit acknowledgement
// before onConfirm() runs the existing submit.
//
// "Kirim Sekarang" is enabled only when `checked` is true and we're not already `sending`.
// Closing (backdrop, X, or "Kembali") calls onBack — it never touches the form state, so
// no typed data or drawn signature is lost.
export default function ConfirmSubmitModal({
  name,
  nim,
  prodiName,
  signatureDataUrl,
  checked,
  onToggleCheck,
  onConfirm,
  onBack,
  sending,
}) {
  return (
    <div className="modal-backdrop" data-testid="confirm-submit-modal" onClick={sending ? undefined : onBack}>
      <div className="modal confirm-submit-modal" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="modal-close" data-testid="confirm-close" onClick={onBack} disabled={sending}>
          <X size={18} />
        </button>
        <div className="eyebrow">SEBELUM MENGIRIM</div>
        <h3>Periksa Kembali Sebelum Mengirim</h3>

        <div className="confirm-summary" data-testid="confirm-summary">
          <div className="confirm-row">
            <span>Nama</span>
            <b data-testid="confirm-name">{name || "—"}</b>
          </div>
          <div className="confirm-row">
            <span>NPM / NIM</span>
            <b data-testid="confirm-nim">{nim || "—"}</b>
          </div>
          {prodiName && (
            <div className="confirm-row">
              <span>Program Studi</span>
              <b>{prodiName}</b>
            </div>
          )}
          <div className="confirm-row confirm-sig">
            <span>Tanda tangan</span>
            {signatureDataUrl ? (
              <img src={signatureDataUrl} alt="Pratinjau tanda tangan Anda" data-testid="confirm-signature-preview" />
            ) : (
              <b className="confirm-missing" data-testid="confirm-signature-missing">Belum ada</b>
            )}
          </div>
        </div>

        <p className="confirm-note">
          Pastikan Anda sudah membaca isi pernyataan, dan menulis Nama, NPM, serta tanda tangan
          dengan teliti. <b>Data yang sudah dikirim TIDAK BISA diubah sendiri</b> — kesalahan harus
          dikoreksi oleh admin.
        </p>

        <label className="confirm-check">
          <input type="checkbox" data-testid="confirm-checkbox" checked={!!checked} onChange={onToggleCheck} />
          <span>Saya sudah memeriksa data di atas dan menyatakan sudah benar</span>
        </label>

        <div className="form-actions">
          <button
            type="button"
            className="outline-btn"
            data-testid="confirm-back-button"
            onClick={onBack}
            disabled={sending}
          >
            Kembali, saya mau periksa lagi
          </button>
          <button
            type="button"
            className="primary-btn"
            data-testid="confirm-send-button"
            onClick={onConfirm}
            disabled={!checked || sending}
          >
            {sending ? "Mengirim..." : "Kirim Sekarang"}
            {!sending && <ChevronRight size={16} />}
          </button>
        </div>
      </div>
    </div>
  );
}
